<template>
  <div class="gather-index">
    <el-card style="margin: 20px;">
      <el-form ref="form" v-loading="loading" label-width="100px" size="small" style="width: 100%">
        <el-form-item label="体检日期：" style="width: 500px">
          <el-date-picker
              v-model="time"
              end-placeholder="结束日期"
              range-separator="至"
              start-placeholder="开始日期"
              style="width:100%"
              type="daterange"
              value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="统计类型：" label-width="100px" style="width: 100%;">
          <statistical-type-select v-model="form.groupType" :clearable="false" :hasSchool="true"></statistical-type-select>
        </el-form-item>
        <el-form-item v-if="isSuperAdmin" label="学校区划：" label-width="100px" style="width: 100%;">
          <el-select v-model="form.province" placeholder="请选择" style="width: 120px;display: inline-block;" @change="getSchools">
            <el-option
                v-for="item in provinceList"
                :key="item.code"
                :label="item.name"
                :value="item.code"
            >
            </el-option>
          </el-select>
          <el-select v-model="form.city" placeholder="请选择" style="width: 120px;display: inline-block;margin-left: 10px;" @change="getSchools">
            <el-option
                v-for="item in cityList"
                :key="item.code"
                :label="item.name"
                :value="item.code">
            </el-option>
          </el-select>
          <el-select v-if="false" v-model="form.county" placeholder="请选择" style="width: 120px;display: inline-block;margin-left: 10px;">
            <el-option
                v-for="item in countryList"
                :key="item.code"
                :label="item.name"
                :value="item.code">
            </el-option>
          </el-select>
        </el-form-item>


        <el-form-item label="体检学校：" style="width:100%;">
          <el-row style="margin-bottom: 10px;">
            <el-col>
              <el-button size="small" type="primary" @click="selectSchools('1')">全选</el-button>
              <el-button size="small" type="danger" @click="selectSchools('2')">取消全选</el-button>
              <el-button size="small" type="warning" @click="selectSchools('3')">反选</el-button>
              <span style="margin-left: 10px;font-weight: bold;">已选{{ form.schoolIds.length }}个学校</span>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <el-select
                  v-model="form.schoolIds"
                  :multiple="true"
                  filterable
                  placeholder="请选择学校"
                  style="width:100%"
              >
                <el-option
                    v-for="item in schools"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                />
              </el-select>
            </el-col>
          </el-row>

        </el-form-item>

        <el-form-item style="text-align: center;">
          <el-button size="large" style="width: 100%;" type="primary" @click="exportWord">导 出</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>
<script>
import ZxxSchoolSelect from "@/components/ZxxSchoolSelect"
import statisticalTypeSelect from "@/components/statisticalTypeSelect"
import * as physicalGatherApi from "@/api/gen/physicalGatherApi"
import * as organizationApi from "@/api/gen/organizationApi"
import {nextTick} from "vue";
import {exportStudentGatherDocxSchools} from "../../api/gen/physicalGatherApi";
import * as areaCodeApi from "@/api/gen/areaCodeApi";

let year = new Date().getFullYear();
export default {
  components: {
    ZxxSchoolSelect,
    statisticalTypeSelect
  },
  props: {
    type: "",
    cells: []
  },
  data() {
    return {
      multiple: false,
      time: [year + "-01-01", year + "-12-31"],
      schools: [],
      checkItems: [],
      debarCheckItem: ['p067', 'p051', 'p007', 'p059', 'p069', 'p057', 'p002', 'p003', 'p004'],
      defNotCheckItem: [''],
      loading: false,
      provinceList: [],
      isSuperAdmin: false,
      form: {
        time: [],
        province: '460000',
        city: undefined,
        county: undefined,
        groupType: '',
        schoolId: '',
        schoolIds: [],
        abnormalCheckItem: []
      },
    }
  },
  watch: {
    'form.province': {
      handler(n, o) {
        if (!o) {
          return;
        }
        this.form.city = this.cityList[0].code
      }
    },
    'form.city': {
      handler(n, o) {
        if (!o) {
          return;
        }
        //this.form.county = this.countryList[0].code
      }
    }
  },
  computed: {
    cityList() {
      for (const item of this.provinceList) {
        if (item.code === this.form.province) {
          return item.children
        }
      }
      return [];
    },
    countryList() {
      for (const item of this.cityList) {
        if (item.code === this.form.city) {
          return item.children
        } else {
          continue
        }
      }
      return []
    }
  },
  async mounted() {
    this.isSuperAdmin = this.$store.getters.isSuperAdmin || this.$hasPermission('allZxxSchool') || this.$store.getters.username === 'admin';
    await nextTick();
    if (this.isSuperAdmin) {
      await this.loadCity();
    }

    await this.getSchools();
    this.form.groupType = "$school";
  },
  methods: {
    async loadCity() {
      const res = (await areaCodeApi.list({pageSize: 10000}))
      this.provinceList = res.data
    },
    async getSchools() {
      this.loading = true;
      await nextTick();
      try {
        this.form.schoolId = '';
        this.form.schoolIds = [];
        if (this.isSuperAdmin) {
          this.schools = [];
          this.schools = (await organizationApi.list({
            province: this.form.province ?? undefined,
            city: this.form.city ?? undefined,
            pageSize: 100000
          })).data.filter(item => item.type === 3)
        } else {
          let tmp = (await organizationApi.getById({id: this.$store.getters.organizationId})).schools
          if (!tmp) {
            return
          }
          if (tmp.length) {
            let res = (await organizationApi.getById({id: this.$store.getters.organizationId}))
            this.schools = (await organizationApi.list({
              id: this._.chain(res.schools).join(",").value(),
              pageSize: 100000
            })).data.filter(item => item.type === 3)
          }
        }
      } catch (e) {
        alert(e.toString())
      } finally {
        this.loading = false;
      }
    },

    //选择学校 1=全选 2=取消全选 3=反选
    async selectSchools(type) {
      if (type == '1') {
        this.form.schoolIds = this.schools.map((item) => {
          return item.id
        });
      } else if (type == '2') {
        this.form.schoolIds = [];
      } else if (type == '3') {
        let schoolIds = [];
        this.schools.forEach((item) => {
          let has = this.form.schoolIds.findIndex(f => f == item.id) >= 0;
          if (!has) {
            schoolIds.push(item.id);
          }
        });
        this.form.schoolIds = schoolIds;
      }
    },
    async getCheckList() {
      //const list = await physicalGatherApi.getCheckList();
      //this.checkItems = list.data.filter(f => this.debarCheckItem.filter(dci => dci == f.checkItemVO.code).length == 0);
    },
    base64ToBlob(base64Data, contentType = '', sliceSize = 512) {
      // 移除可能的Base64前缀
      const base64WithoutPrefix = base64Data.split(';base64,').pop();

      // 解码Base64
      const byteCharacters = atob(base64WithoutPrefix);
      const byteArrays = [];

      for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);
        const byteNumbers = new Array(slice.length);

        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        byteArrays.push(new Uint8Array(byteNumbers));
      }

      return new Blob(byteArrays, {type: contentType});
    },
    async exportWord() {
      try {
        this.loading = true;
        this.form.time = this.time;

        let clone = {...this.form}
        if (clone.schoolIds.length == 0) {
          alert("请选择学校")
          return;
        }
        if (clone.schoolIds.length == 1) {
          clone.schoolId = clone.schoolIds[0];
        }
        let res = null;
        if (clone.schoolId && clone.schoolId != '') {
          res = await physicalGatherApi.exportStudentGatherDocx(clone);
        } else {
          res = await physicalGatherApi.exportStudentGatherDocxSchools(clone);
        }
        const base64 = res.base64;
        const title = res.title;
        const blob = this.base64ToBlob(base64);
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = title + '.docx';
        link.click();
      } finally {
        this.loading = false;
      }

    }
  }
}
</script>
<style scoped>
.gather-index {
  .el-select {
    width: 100%;
  }
}
</style>